module.exports = __webpack_public_path__ + "static/media/icon-arrow--up-med-gray.69653197.svg";